import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import PendingUserEntityMemberInvitation from "legal-entities/invitations/member-invitations/email-based/pending/pending-user-entity-member-invitation";

const InvitationsTable = styled(Paper)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
  padding: theme.spacing(6),
  position: "relative",
}));

const InvitationsTableTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}));

type PendingUserEntityMemberInvitationsTableProps = {
  invitations: PendingUserEntityMemberInvitation[];
};

export default function PendingUserEntityMemberInvitationsTable(
  props: Readonly<PendingUserEntityMemberInvitationsTableProps>,
) {
  const { invitations } = props;

  return (
    <InvitationsTable>
      <InvitationsTableTitle variant="h6">Email Invitations</InvitationsTableTitle>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">Id</TableCell>
            <TableCell align="left">Email Address</TableCell>
            <TableCell align="left">Entity Name</TableCell>
            <TableCell align="left">User Role</TableCell>
            <TableCell align="left">Business Role</TableCell>
            <TableCell align="left">Expires</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invitations.length < 1 && (
            <TableRow>
              <TableCell colSpan={3}>
                <Typography>No Pending Invitations</Typography>
              </TableCell>
            </TableRow>
          )}
          {invitations.map((invitation: PendingUserEntityMemberInvitation) => (
            <TableRow key={invitation.id?.value}>
              <TableCell align="left">
                <Typography className="invitation-id">{invitation.id?.value ?? ""}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography className="invitation-entity">{invitation.userEmail?.value ?? ""}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>{invitation.entityName}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>{invitation.isAdmin ? "Administrator" : "Member"}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>
                  {invitation.createClientRep && !invitation.createVendorRep && "Client"}
                  {invitation.createVendorRep && !invitation.createClientRep && "Vendor"}
                  {invitation.createClientRep && invitation.createVendorRep && "Client, Vendor"}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>{invitation.expires.format("MM/DD/YY")}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </InvitationsTable>
  );
}
